import { phoneState } from '../state';
import IWebPhoneService from '../IWebPhoneService';
import { CallState, WebphonePhoneStateEvent } from '../types';
import { webPhoneLastTriggeringEventNames } from '../WebPhoneService';
import getPcsConversation from '../lib/getPcsConversation';
import IAppLogger from '@app/lib/IAppLogger';
import getInitialRecordingState, {
  defaultRecordingState,
} from '../lib/getInitialRecordingState';
import handleCallStateUpdate from './handleCallStateUpdate';
import handleCallPlaced from './handleCallPlaced';
import handleCheckWebPhoneRegistration from './handleCheckWebPhoneRegistration';

const handleWebPhonePhoneStateUpdate = async (
  webPhoneService: IWebPhoneService,
  phoneStateUpdateEvent: WebphonePhoneStateEvent,
  logger: IAppLogger,
) => {
  phoneState.phoneConnected = phoneStateUpdateEvent.phoneConnected;
  phoneState.registrationFailed = phoneStateUpdateEvent.registrationFailed;

  // webphone call started
  if (
    phoneStateUpdateEvent.triggeringEvent ===
    webPhoneLastTriggeringEventNames.callStarted
  ) {
    const newCallState: CallState = {
      ...phoneStateUpdateEvent.callState,
      pcsConversationSid: '',
      queueIds: [],
      recordingState: defaultRecordingState,
    };
    try {
      // get pcsConversation
      const pcsConversation = await getPcsConversation(
        phoneStateUpdateEvent.callState.remoteCallId,
      );

      if (!pcsConversation) {
        throw new Error(
          `PcsConversation not found for remoteCallId ${phoneStateUpdateEvent.callState.remoteCallId}}`,
        );
      }
      // calculate initial recording state based on call direction and queueIds
      const initialRecordingState = getInitialRecordingState(
        phoneStateUpdateEvent.callState.direction,
        pcsConversation.queueIds,
      );

      newCallState.pcsConversationSid = pcsConversation.sid;
      newCallState.queueIds = pcsConversation.queueIds;
      newCallState.recordingState = initialRecordingState;
    } catch (error) {
      logger.error(error);
    }
    phoneState.callList[phoneStateUpdateEvent.callState.callId] = newCallState;

    handleCallPlaced(webPhoneService, newCallState, logger);
  } else if (phoneStateUpdateEvent.triggeringEvent) {
    // handle call state update
    handleCallStateUpdate(
      webPhoneService,
      phoneStateUpdateEvent.callState,
      logger,
    );
  }

  // delete call from callList when call ends and it longer exists in the callList
  if (
    phoneStateUpdateEvent.triggeringEvent ===
      webPhoneLastTriggeringEventNames.callEnded &&
    !phoneStateUpdateEvent.callList.find(
      (call) => call.callId === phoneStateUpdateEvent.callState.callId,
    )
  ) {
    delete phoneState.callList[phoneStateUpdateEvent.callState.callId];

    // whenever a call ends we should check if the webphone registration is still valid
    handleCheckWebPhoneRegistration();
  }
};

export default handleWebPhonePhoneStateUpdate;
